import './App.css';

import * as React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import LoginButton  from "./components/Controls/LoginButton";

import Layout from './components/Layout'
import {IDPoolProvider} from "./components/Context/IDContext";
import {Header} from "./components/Header/Header";
const identityServer =  process.env.NODE_ENV==="development" ?  "http://127.0.0.1:8000" : ""


function App() {
    const { user, isAuthenticated, isLoading} = useAuth0();

    if (isLoading) {
        return (<div>Loading ...</div>);
    }

    if ( ! isAuthenticated ) {
        return (<div><Header/></div>)
    }
    return ( isAuthenticated && (
        <IDPoolProvider>
            <Layout/>
        </IDPoolProvider>
        )
  );
}

export default App;
